export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успіх"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Помилка"])}
}